import { ForwardedRef } from 'react';

const updateForwardedRef = <T>(refToUpdate: ForwardedRef<T>, currentValue: T | null) => {
  if (!refToUpdate) return;
  if (typeof refToUpdate === 'function') {
    refToUpdate(currentValue);
  } else {
    refToUpdate.current = currentValue;
  }
};
export { updateForwardedRef };
